import { render, staticRenderFns } from "./FormPriceInput.vue?vue&type=template&id=600dbd43&scoped=true&"
import script from "./FormPriceInput.vue?vue&type=script&lang=js&"
export * from "./FormPriceInput.vue?vue&type=script&lang=js&"
import style0 from "./FormPriceInput.vue?vue&type=style&index=0&id=600dbd43&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600dbd43",
  null
  
)

export default component.exports